import { render, staticRenderFns } from "./tailoring.vue?vue&type=template&id=80616e90&"
import script from "./tailoring.vue?vue&type=script&lang=js&"
export * from "./tailoring.vue?vue&type=script&lang=js&"
import style0 from "./tailoring.vue?vue&type=style&index=0&id=80616e90&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports